"use strict";


var SOAModel = require('bunsen/models/SoaModel');

var ModalEmailModel = module.exports = SOAModel.extend();

var _ = require('underscore');
var currencyParseFloat = require('dibs-currency-helpers/util').parseFloat;
var MEC = require('../modalEmailConstants');
var Backbone = require('dibs-backbone');
var UserModel = require('../../../../global/models/User');
var SMTPMessage = require('./SMTPMessage');
var SV = require('server-vars');

/**
 * parses and interprets severvars,
 * determines SMTP or Usercomm for message flow
 * determines currency based on available user info
 */

_.extend(ModalEmailModel.prototype, {
    defaults : {
        type        : 'dealer',
        pageType    : 'seller',
        queryString : '',
        currency    : MEC.CURRENCY_DEFAULT,
        isMobile    : false,
        tracking    : {}
    },
    relations: function () {
        return [
            {
                key : 'pageSV',
                relatedModel : Backbone.AssociatedModel.extend(),
                type : Backbone.One
            },
            {
                key : 'tracking',
                relatedModel : Backbone.AssociatedModel.extend(),
                type : Backbone.One
            },
            {
                key : 'user',
                relatedModel : UserModel,
                type: Backbone.One
            }
        ];
    },
    initialize : function () {
        var type = this.get('type');
        var message;
        if (!this.get('message')) {
            message  = new SMTPMessage(); // email friend messages are sent through smtp
            message.url = ['', 'email', type, ''].join('/') + this.get('queryString');
            this.set('message', message);
        }
        if (this.get('pageSV')) {
            this.set('shouldShowPrice', this.getShouldShowPrice());
        }
        this.on('change:pageSV', function () {
            this.set('shouldShowPrice', this.getShouldShowPrice());
        });
        if (this.get('user') && this.get('user.profile')) {
            this.set('currency', this.get('user.profile.currency') || MEC.CURRENCY_DEFAULT);
        }
        this.on('change:user.profile change:user', function () {
            this.set('currency', this.get('user.profile.currency'));
        });
    },
    getAjaxContentPath : function () {
        return (this.get('pageType') === 'seller' ? '/seller/modal/email/' : '/item/ajax/email/') +
               this.get('queryString');
    },
    /**
     * sugar method for input default, blank string if user is not logged in
     * @returns {String}
     */
    getUserName : function () {
        var name = '';
        var lastName;
        if (this.get('user') && this.get('user.profile')) {
            name = this.get('user.profile.firstName') || '';
            lastName = this.get('user.profile.lastName') || '';
            if (name && lastName) {
                name += ' ';
            }
            name += lastName;
        }
        return name;
    },
    /**
     * sugar method for input default, blank string if user is not logged in
     * @returns {String}
     */
    getUserEmail : function () {
        if (this.get('user') && this.get('user.profile')) {
            return this.get('user.profile.email');
        }
        return '';
    },
    /**
     * sugar method for determining whether or not to show price
     * @returns {boolean}
     */
    getShouldShowPrice : function () {
        return this.get('pageType') === 'item' &&
            !this.get('pageSV.isHidePrice') &&
            !this.get('pageSV.isSold') &&
            !this.get('pageSV.isHold');
    },
    /**
     * sugar method for currency converted list price
     * all prices come back with periods for decimals, not commas
     * so no need to format the numbers before passing into parseFloat
     * @returns {Number}
     */
    getListPrice : function () {
        var price = SV.get('modalData.priceCurrencies')[this.get('currency')] + '';
        return currencyParseFloat(price);
    },
    /**
     * based on currency preference, returns regex and error message for dibsvalidation validator
     * required parameter defaults to true
     * @returns {{required: boolean, messages: {number_required: string}, regex_rules: {number_required: *}}}
     */
    getCurrencyValidation : function () {
        var msg = MEC.msgs.numberFormat;
        var regExs;
        var noMatchRegEx;
        var regEx;
        switch (this.get('currency')) {
            case MEC.CURRENCY_EU :
                regExs = MEC.CURRENCY_REGEX_EU;
                regEx = regExs.numFormat;
                noMatchRegEx = regExs.zeroInput;
                msg = msg + '###.###';
                break;
            default:
                regExs = MEC.CURRENCY_REGEX_DEFAULT;
                regEx = regExs.numFormat;
                noMatchRegEx = regExs.zeroInput;
                msg = msg + '###,###';
                break;
        }
        return {
            required: true,
            messages: {
                number_required : msg,
                zero: SV.get('modalData.validationCopy').zeroMessage
            },

            regex_rules: {
                number_required : regEx
            },
            regex_nomatch_rules: {
                zero: noMatchRegEx
            }
        };
    },
    getShareEmailTracking: function () {
        var shared = this.get('message.emailDataMap.isShowSenderEmail') === true;
        return 'share=' + (shared ? 'y' : 'n');
    },
    getFavDealerCtasTracking: function () {
        var showing = this.get('showingFavDealerCtas');
        return 'fav=' + (showing ? 'y' : 'n');
    },
    getPlaceholderCopy: function () {
        var copy = SV.get('modalData.copy');
        var pageType = this.get('pageType') === 'item' ? 'Pdp' : 'Storefront';
        return copy ? copy['placeholder' + pageType] : '';
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/js/global/modules/modalEmail/models/ModalEmailModel.js
// module id = 1188
// module chunks = 4 7 12